import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ActorProvider } from "@/context/ActorContext";

// Layouts
import DashboardLayout from "@/components/layouts/DashboardLayout";

// MOE HQ Pages
import MOEDashboard from "@/pages/moe/Dashboard";
import MOECycleSetup from "@/pages/moe/CycleSetup";
import MOECurationApproval from "@/pages/moe/CurationApproval";
import MOEQuoteApproval from "@/pages/moe/QuoteApproval";
import MOESchoolMonitor from "@/pages/moe/SchoolMonitor";
import MOEPilotManagement from "@/pages/moe/PilotManagement";
import MOEMKProgramme from "@/pages/moe/MKProgramme";
import MOEReports from "@/pages/moe/Reports";

// Civica Pages
import CivicaDashboard from "@/pages/civica/Dashboard";
import CivicaCurationManagement from "@/pages/civica/CurationManagement";
import CivicaQuoteInvitations from "@/pages/civica/QuoteInvitations";
// Removed AcquisitionUpload - not needed
import CivicaPOCollation from "@/pages/civica/POCollation";
import CivicaDeliveryStatus from "@/pages/civica/DeliveryStatus";
import CivicaInvoicing from "@/pages/civica/Invoicing";

// School (RGS) Pages
import SchoolDashboard from "@/pages/school/Dashboard";
import SchoolBudgetSetup from "@/pages/school/BudgetSetup";
import SchoolTitleSelection from "@/pages/school/TitleSelection";
import SchoolPayPerUse from "@/pages/school/PayPerUse";
import SchoolOrders from "@/pages/school/Orders";
import SchoolOrderDetails from "@/pages/school/OrderDetails";

// Supplier (OpenTrolley) Pages
import SupplierDashboard from "@/pages/supplier/Dashboard";
import SupplierQuoteResponse from "@/pages/supplier/QuoteResponse";
import SupplierPOFulfilment from "@/pages/supplier/POFulfilment";
import SupplierOrderHistory from "@/pages/supplier/OrderHistory";

// MK Pages
import MKDashboard from "@/pages/mk/Dashboard";
import MKBookOrder from "@/pages/mk/BookOrder";
import MKDeliveryTracking from "@/pages/mk/DeliveryTracking";

// Actor Selection Page
import ActorSelection from "@/pages/ActorSelection";

import "@/App.css";

function App() {
  return (
    <ActorProvider>
      <BrowserRouter>
        <Routes>
          {/* Actor Selection */}
          <Route path="/" element={<ActorSelection />} />
          
          {/* MOE HQ Routes */}
          <Route path="/moe" element={<DashboardLayout />}>
            <Route index element={<Navigate to="/moe/dashboard" replace />} />
            <Route path="dashboard" element={<MOEDashboard />} />
            <Route path="cycle-setup" element={<MOECycleSetup />} />
            <Route path="curation-approval" element={<MOECurationApproval />} />
            <Route path="quote-approval" element={<MOEQuoteApproval />} />
            <Route path="school-monitor" element={<MOESchoolMonitor />} />
            <Route path="pilot-management" element={<MOEPilotManagement />} />
            <Route path="mk-programme" element={<MOEMKProgramme />} />
            <Route path="reports" element={<MOEReports />} />
          </Route>
          
          {/* Civica Routes */}
          <Route path="/civica" element={<DashboardLayout />}>
            <Route index element={<Navigate to="/civica/dashboard" replace />} />
            <Route path="dashboard" element={<CivicaDashboard />} />
            <Route path="curation" element={<CivicaCurationManagement />} />
            <Route path="quote-invitations" element={<CivicaQuoteInvitations />} />
            {/* Removed acquisition-upload route */}
            <Route path="po-collation" element={<CivicaPOCollation />} />
            <Route path="delivery-status" element={<CivicaDeliveryStatus />} />
            <Route path="invoicing" element={<CivicaInvoicing />} />
          </Route>
          
          {/* School (RGS) Routes */}
          <Route path="/school" element={<DashboardLayout />}>
            <Route index element={<Navigate to="/school/dashboard" replace />} />
            <Route path="dashboard" element={<SchoolDashboard />} />
            <Route path="budget-setup" element={<SchoolBudgetSetup />} />
            <Route path="title-selection" element={<SchoolTitleSelection />} />
            <Route path="pay-per-use" element={<SchoolPayPerUse />} />
            <Route path="orders" element={<SchoolOrders />} />
            <Route path="orders/:orderId" element={<SchoolOrderDetails />} />
          </Route>
          
          {/* Supplier (OpenTrolley) Routes */}
          <Route path="/supplier" element={<DashboardLayout />}>
            <Route index element={<Navigate to="/supplier/dashboard" replace />} />
            <Route path="dashboard" element={<SupplierDashboard />} />
            <Route path="quote-response" element={<SupplierQuoteResponse />} />
            <Route path="po-fulfilment" element={<SupplierPOFulfilment />} />
            <Route path="order-history" element={<SupplierOrderHistory />} />
          </Route>
          
          {/* MK Routes */}
          <Route path="/mk" element={<DashboardLayout />}>
            <Route index element={<Navigate to="/mk/dashboard" replace />} />
            <Route path="dashboard" element={<MKDashboard />} />
            <Route path="book-order" element={<MKBookOrder />} />
            <Route path="delivery-tracking" element={<MKDeliveryTracking />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </ActorProvider>
  );
}

export default App;
